<template>
  <a-table
    :columns="columns"
    :data-source="list"
    :loading="loading"
    :pagination="{ defaultPageSize: 10 }"
    :row-key="() => Math.random().toString().slice(2)"
  >
    <template slot="gallery_title" slot-scope="item">
      <a-row align="middle" type="flex" class="fl-no-wrap">
        <a-avatar
          :size="86"
          :src="
            item.files && item.files.length && filesUrl + item.files[0].file
          "
          class="mr-1x"
          icon="picture"
          shape="square"
        />
        {{ item.title[$i18n.locale] || "Нет заголовки" }}
      </a-row>
    </template>

    <template slot="operation" slot-scope="item">
      <a-icon
        class="action-btns"
        type="edit"
        @click="
          $router.push({ name: 'gallery-detail', params: { id: item.id } })
        "
      />
      <a-popconfirm
        title="Вы действительно хотите удалить?"
        cancel-text="Нет"
        ok-text="Да"
        @confirm="removeItem(item)"
      >
        <a-icon class="action-btns" style="margin: 0 10px" type="delete" />
      </a-popconfirm>
    </template>
  </a-table>
</template>

<script>
const columns = [
  {
    title: "Название",
    key: "title",
    scopedSlots: { customRender: "gallery_title" }
  },
  {
    title: "Действие",
    key: "operation",
    scopedSlots: { customRender: "operation" },
    width: 160
  }
]
export default {
  data: () => ({
    columns,
    loading: false,
    list: []
  }),
  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    }
  },
  methods: {
    async fetchData() {
      // if (this.$route.query.tab != 'photo') {
      //   return
      // }
      this.loading = true
      try {
        const data = await this.$store.dispatch("gallery/fetch", {
          type: 0
        })

        if (data && data.results) {
          const d = data.results.map((item) => ({
            ...item,
            title: this.dataParse(item.title)
          }))

          this.$set(this, "list", d)
        }

        // console.log('ptb', data)
      } catch (err) {
        console.log(err)
      }

      this.loading = false
    },

    async removeItem(arg) {
      if (arg && arg.id) {
        const res = await this.$store.dispatch(
          "gallery/removeItemAction",
          arg.id
        )
        if (res) {
          const f = this.list.findIndex((item) => item.id == arg.id)

          if (f != -1) {
            this.list.splice(f, 1)
          }
        }
      }
    }
  }
}
</script>
